import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import pl from "date-fns/locale/pl";
import EventDialog from "./EventDialog";
import CustomEvent from "./CustomEvent";
import normalizeDateString from "./helpers/normalizeDate";
import { useSelector } from "react-redux";
import { Alert, Box, Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { joinEvent, leaveEvent } from "../../API/callendarApi";
import axios from "axios";
import CustomAgendaEvent from "./CustomAgendaEvent";
import ImportEventsButton from "./ImportEventsButton";
import ImportEventsDialog from "./ImportEventsButton";

const locales = {
    // "en-US": require("date-fns/locale/en-US"),
    "pl-PL": pl,
};

const messagesPL = {
    today: "Dzisiaj",
    previous: "Poprzedni",
    next: "Następny",
    month: "Miesiąc",
    week: "Tydzień",
    day: "Dzień",
    agenda: "Agenda",
    date: "Data",
    time: "Godzina",
    event: "Wydarzenie",
    noEventsInRange: "Brak wydarzeń w tym zakresie",
    showMore: (total) => `+${total} więcej`,
};

const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales });
const DnDCalendar = withDragAndDrop(Calendar);

const EVENT_TYPE_COLORS = {
    1: "#47be2f",
    vr: "#294e6b",
    // vr_special: "#1e4a5e",
    vr_special: "linear-gradient(135deg, #1e4a5e 0%, #294e6b 50%, #6cc6d9 100%)",
    vr_seasonal: "#899cab",
    training: "#43babaff",
    event: "#ff8235ff",
    meeting: "#f59e0b",
    information: "#8b5cf6",
};

const roles = { ADMIN: "admin", VIEWER: "viewer" };

const mapApiEventToCalendarEvent = (apiEvent) => ({
    id: apiEvent.id,
    title: apiEvent.name,
    start: new Date(apiEvent.startDate),
    end: new Date(apiEvent.endDate),
    meta: {
        scenario: apiEvent.scenario ?? null,
        description: apiEvent.description,
        type: apiEvent.type,
        status: apiEvent.status,
        isRecurring: apiEvent.isRecurring,
        createdAt: apiEvent.createdAt,
        updatedAt: apiEvent.updatedAt,
        MaxPlayers: apiEvent.MaxPlayers,
        RequiredPlayersToStart: apiEvent.RequiredPlayersToStart,
        creator: { id: apiEvent?.creator?.openBadgeId, name: apiEvent?.creator?.username },
        participants: apiEvent?.participants?.map(p => ({
            id: p.openBadgeId,
            name: p.username,
        })) ?? [],
    },
});

const mapFormToApiPayload = (data) => ({
    name: data.name,
    description: data.description ?? null,
    type: data.type ?? undefined,
    scenario: data.scenario ?? undefined,
    startDate: toISOStringSafe(data.startDate),
    endDate: toISOStringSafe(data.endDate),
    isRecurring: data.isRecurring,
    MaxPlayers: data.MaxPlayers,
    RequiredPlayersToStart: data.RequiredPlayersToStart,
    pin: data.pin ?? null,
});

const toISOStringSafe = (value) => {
    if (!value) return null;
    const date = normalizeDateString(value);
    if (!(date instanceof Date) || isNaN(date)) throw new Error("Invalid date value");
    return date.toISOString();
};

const mapFormVrEvents = (data) => {
    const date = normalizeDateString(data.setup.date);
    return {
        id: Math.random().toString(36).substr(2, 9),
        title: data.setup.roomName,
        start: date,
        end: date,
        meta: {
            scenario: data.setup.scenario ?? null,
            description: "VR",
            type: data.type ?? "special",
            status: data.live ? "live" : "upcoming",
            isRecurring: false,
            createdAt: date,
            updatedAt: date,
            MaxPlayers: data.setup.maxPlayers,
            RequiredPlayersToStart: data.setup.requiredPlayersToStart,
            creator: { id: null, name: "VR Lobby" },
            participants: data.players?.map(p => ({ id: p.id, name: p.name })) || [],
        },
    };
};

export default function EventsCalendar({ userRole }) {
    const { user: storedUser, accessToken: token } = useSelector((state) => state.auth);

    const [events, setEvents] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("global");
    const [scenarioNamesForPicker, setScenarioNamesForPicker] = useState([]);
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);

    const [openImport, setOpenImport] = useState(false);

    useEffect(() => {
        const fetchGroups = async () => {
            if (!token) return;
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/users-permissions/auth/my-groups`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log("fetched groups:", res.data);
            setGroups(res.data);
        };
        fetchGroups();
    }, []);

    console.log("groupsssss:", groups);
    console.log("jwttt:", token);

    useEffect(() => {
        if (!token) return;
        const controller = new AbortController();
        const signal = controller.signal;

        // const fetchEvents = async () => {
        //     setLoading(true);
        //     try {
        //         let apiEvents = [];
        //         let vrEvents = [];
        //         let scenarios = [];

        //         if (!selectedGroup || selectedGroup === "global") {
        //             const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, { headers: { Authorization: `Bearer ${token}` }, signal });
        //             const data = await res.json();
        //             apiEvents = data.map(mapApiEventToCalendarEvent);

        //             const res2 = await fetch(`${process.env.REACT_APP_API_URL_VR}/server/map`, { signal });
        //             const data2 = await res2.json();
        //             vrEvents = data2?.lobbies.map(mapFormVrEvents) || [];

        //             const res3 = await fetch("https://strapitest.vccsystem.eu/api/scenario-names", { signal });
        //             const data3 = await res3.json();
        //             scenarios = data3?.data?.map(s => ({
        //                 name: s.attributes.displayName,
        //                 scenarioName: s.attributes.name,
        //             })) || [];
        //         } else {
        //             const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups`, {
        //                 method: "POST",
        //                 headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        //                 body: JSON.stringify({ groups: [selectedGroup] }),
        //                 signal,
        //             });
        //             const data = await res.json();
        //             apiEvents = Array.isArray(data) ? data.map(mapApiEventToCalendarEvent) : [];
        //         }

        //         setEvents([...apiEvents, ...vrEvents]);
        //         setScenarioNamesForPicker(scenarios);
        //     } catch (err) {
        //         if (err.name !== "AbortError") console.error(err);
        //     } finally {
        //         setLoading(false);
        //     }
        // };

        const fetchEvents = async () => {
            setLoading(true);
            try {
                let apiEvents = [];
                let vrEvents = [];
                let scenarios = [];

                if (!selectedGroup || selectedGroup === "global") {
                    const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, {
                        headers: { Authorization: `Bearer ${token}` },
                        signal
                    });
                    const data = await res.json();
                    apiEvents = data.map(mapApiEventToCalendarEvent);

                    const res2 = await fetch(`${process.env.REACT_APP_API_URL_VR}/server/map`, { signal });
                    const data2 = await res2.json();
                    vrEvents = data2?.lobbies.map(mapFormVrEvents) || [];

                    // const res3 = await fetch("https://strapitest.vccsystem.eu/api/scenario-names", { signal });
                    const res3 = await fetch(`${process.env.REACT_APP_API_URL}/scenario-names?pagination[pageSize]=1000`, { signal });
                    const data3 = await res3.json();
                    scenarios = data3?.data?.map(s => ({
                        name: s.attributes.displayName,
                        scenarioName: s.attributes.name,
                    })) || [];

                    const mergedEvents = [...apiEvents];

                    vrEvents.forEach(vr => {
                        const duplicate = mergedEvents.find(e =>
                            e.title === vr.title &&
                            e.start.getTime() === vr.start.getTime()
                        );
                        if (duplicate) {
                            duplicate.meta.isVR = true;
                        } else {
                            mergedEvents.push(vr);
                        }
                    });

                    setEvents(mergedEvents);
                    setScenarioNamesForPicker(scenarios);

                } else {
                    const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                        body: JSON.stringify({ groups: [selectedGroup] }),
                        signal,
                    });
                    const data = await res.json();
                    apiEvents = Array.isArray(data) ? data.map(mapApiEventToCalendarEvent) : [];
                    setEvents(apiEvents);
                }

            } catch (err) {
                if (err.name !== "AbortError") console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
        return () => controller.abort();
    }, [token, selectedGroup]);

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedEvent(null);
        setSelectedSlot(null);
    };

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
        setDialogOpen(true);
    };

    const handleSelectSlot = (slot) => {
        setSelectedSlot(slot);
        setSelectedEvent(null);
        setDialogOpen(true);
    };

    const handleSaveEvent = async (data) => {
        console.log("Saving event with data22222:", data);
        const payload = mapFormToApiPayload(data);

        if (selectedEvent) {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${selectedEvent.id}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify(payload),
            });
            const updated = await res.json();
            const updatedEvent = mapApiEventToCalendarEvent(updated);

            setEvents(prev => prev.map(evt => (evt.id === updatedEvent.id ? updatedEvent : evt)));
            setSelectedEvent(updatedEvent);
        } else {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify({ ...payload, groups: [selectedGroup] }),
            });
            const created = await res.json();
            const createdEvent = mapApiEventToCalendarEvent(created);

            setEvents(prev => [...prev, createdEvent]);
            setSelectedEvent(createdEvent);
        }
    };

    const handleDeleteEvent = async () => {
        if (!selectedEvent) return;
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${selectedEvent.id}`, {
                method: "DELETE",
                headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
            });
            if (!res.ok) throw new Error("Nie udało się usunąć wydarzenia");
            setEvents(prev => prev.filter(evt => evt.id !== selectedEvent.id));
            setAlert({ severity: "success", message: "Event usunięty" });
            handleCloseDialog();
        } catch (err) {
            setAlert({ severity: "error", message: err.message });
        }
    };

    const handleJoin = async (id) => {
        try {
            const updated = await joinEvent(id, token);
            const updatedEvent = mapApiEventToCalendarEvent(updated);

            setEvents(prev => prev.map(evt => (evt.id === id ? updatedEvent : evt)));
            if (selectedEvent?.id === id) setSelectedEvent(updatedEvent);
            setAlert({ severity: "success", message: "Dołączono do wydarzenia" });
        } catch (err) {
            setAlert({ severity: "error", message: err.message });
        }
    };

    const handleLeave = async (id) => {
        try {
            const updated = await leaveEvent(id, token);
            const updatedEvent = mapApiEventToCalendarEvent(updated);

            setEvents(prev => prev.map(evt => (evt.id === id ? updatedEvent : evt)));
            if (selectedEvent?.id === id) setSelectedEvent(updatedEvent);
            setAlert({ severity: "success", message: "Wypisano z wydarzenia" });
        } catch (err) {
            setAlert({ severity: "error", message: err.message });
        }
    };

    const handleChangeGroup = (e) => setSelectedGroup(e.target.value);

    const eventStyleGetter = (event) => {
        const type = event?.meta?.type;
        const backgroundColor = EVENT_TYPE_COLORS[type] || "#6b7280";
        return { style: { backgroundColor, color: "white", borderRadius: "6px", border: "none" } };
    };

    const handleEventResize = ({ event, start, end }) => {
        if (userRole !== roles.ADMIN) return;
        setEvents(events.map(evt => (evt.id === event.id ? { ...evt, start, end } : evt)));
    };

    const handleEventDrop = async ({ event, start, end }) => {
        if (userRole !== roles.ADMIN) return;
        const updatedEvent = { ...event, start, end };
        setEvents(prev => prev.map(evt => (evt.id === event.id ? updatedEvent : evt)));

        await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${event.id}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify({ name: event.title, startDate: toISOStringSafe(start), endDate: toISOStringSafe(end) }),
        });
    };

    return (
        <div style={{ height: "850px", margin: "50px" }}>
            <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel>Wybierz grupę aby wyświetlić wydarzenia do niej przypisane</InputLabel>
                <Select value={selectedGroup} onChange={handleChangeGroup} label="Wybierz grupę aby wyświetlić wydarzenia do niej przypisane">
                    <MenuItem value="global">Publiczne wydarzenia</MenuItem>
                    {groups.map(g => <MenuItem key={g.id} value={g.code}>{g.name}</MenuItem>)}
                </Select>
            </FormControl>

            {/* {alert && <Alert variant="outlined" severity={alert.severity} sx={{ mb: 2 }}>{alert.message}</Alert>} */}

            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>


                <Button variant="outlined" onClick={() => setOpenImport(true)}>
                    Importuj wydarzenia
                </Button>

                <ImportEventsDialog
                    token={token}
                    open={openImport}
                    onClose={() => setOpenImport(false)}
                    selectedGroupCode={selectedGroup}
                />
            </Box>

            <DnDCalendar
                popup
                localizer={localizer}
                events={events}
                // components={{ event: CustomEvent }}
                components={{
                    event: CustomEvent,
                    agenda: {
                        event: CustomAgendaEvent,
                    },
                }}
                startAccessor="start"
                endAccessor="end"
                culture="pl-PL"
                messages={messagesPL}
                selectable={userRole === roles.ADMIN}
                onSelectSlot={handleSelectSlot}
                onSelectEvent={handleSelectEvent}
                onEventDrop={handleEventDrop}
                onEventResize={handleEventResize}
                resizable
                eventPropGetter={eventStyleGetter}
            />

            <EventDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                onSave={handleSaveEvent}
                onDelete={handleDeleteEvent}
                slot={selectedSlot}
                event={selectedEvent}
                scenarioNames={scenarioNamesForPicker}
                alert={alert}
                joinEvent={handleJoin}
                leaveEvent={handleLeave}
                currentUser={storedUser}
                selectedGroup={selectedGroup}
            />
        </div>
    );
}



// import React, { useEffect, useState } from "react";
// import { Calendar, dateFnsLocalizer } from "react-big-calendar";
// import format from "date-fns/format";
// import parse from "date-fns/parse";
// import startOfWeek from "date-fns/startOfWeek";
// import getDay from "date-fns/getDay";
// import "react-big-calendar/lib/css/react-big-calendar.css";

// import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
// import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
// import pl from "date-fns/locale/pl";
// import EventDialog from "./EventDialog";
// import CustomEvent from "./CustomEvent";
// import normalizeDateString from "./helpers/normalizeDate";
// import { useSelector } from "react-redux";
// import { Alert, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
// import { joinEvent, leaveEvent } from "../../API/callendarApi";
// import axios from "axios";



// const locales = {
//     // "en-US": require("date-fns/locale/en-US"),
//     "pl-PL": pl,
// };

// const messagesPL = {
//     today: "Dzisiaj",
//     previous: "Poprzedni",
//     next: "Następny",
//     month: "Miesiąc",
//     week: "Tydzień",
//     day: "Dzień",
//     agenda: "Agenda",
//     date: "Data",
//     time: "Godzina",
//     event: "Wydarzenie",
//     noEventsInRange: "Brak wydarzeń w tym zakresie",
//     showMore: (total) => `+${total} więcej`,
// };

// const EVENT_TYPE_COLORS = {
//     1: "#47be2f",
//     vr: "#294e6b",
//     vr_special: "#1f3a57",
//     vr_seasonal: "#899cab",
//     training: "#43babaff",
//     event: "#ff8235ff",
//     meeting: "#f59e0b",
//     information: "#8b5cf6",
// };

// // const toISOStringSafe = (value) => {
// //     if (!value) return null;

// //     // JS Date
// //     if (value instanceof Date) {
// //         return value.toISOString();
// //     }

// //     // dayjs / moment
// //     if (typeof value === 'object' && typeof value.toDate === 'function') {
// //         return value.toDate().toISOString();
// //     }

// //     // ISO string
// //     if (typeof value === 'string') {
// //         return new Date(value).toISOString();
// //     }

// //     throw new Error('Invalid date value');
// // };


// const toISOStringSafe = (value) => {
//     if (!value) return null;

//     const date = normalizeDateString(value);

//     if (!(date instanceof Date) || isNaN(date)) {
//         throw new Error('Invalid date value');
//     }

//     return date.toISOString();
// };


// const localizer = dateFnsLocalizer({
//     format,
//     parse,
//     startOfWeek,
//     getDay,
//     locales,
// });

// const DnDCalendar = withDragAndDrop(Calendar);

// const roles = {
//     ADMIN: "admin",
//     VIEWER: "viewer",
// };

// const people = [
//     { id: 1, name: "Jan" },
//     { id: 2, name: "Anna" },
// ];

// const mapApiEventToCalendarEvent = (apiEvent) => ({
//     id: apiEvent.id,
//     title: apiEvent.name,
//     start: new Date(apiEvent.startDate),
//     end: new Date(apiEvent.endDate),
//     meta: {
//         scenario: apiEvent.scenario ?? null,
//         description: apiEvent.description,
//         type: apiEvent.type,
//         status: apiEvent.status,
//         isRecurring: apiEvent.isRecurring,
//         createdAt: apiEvent.createdAt,
//         updatedAt: apiEvent.updatedAt,
//         MaxPlayers: apiEvent.MaxPlayers,
//         RequiredPlayersToStart: apiEvent.RequiredPlayersToStart,
//         creator: { id: apiEvent?.creator?.openBadgeId, name: apiEvent?.creator?.username },
//         participants: apiEvent?.participants?.map((participant) => ({
//             id: participant.openBadgeId,
//             name: participant.username,
//         })) ?? [],
//     },
// });

// const mapFormToApiPayload = (data) => ({
//     name: data.name,
//     description: data.description ?? null,
//     type: data.type ?? undefined,
//     scenario: data.scenario ?? undefined,
//     startDate: toISOStringSafe(data.startDate),
//     endDate: toISOStringSafe(data.endDate),
//     isRecurring: data.isRecurring,
//     MaxPlayers: data.MaxPlayers,
//     RequiredPlayersToStart: data.RequiredPlayersToStart,
// });


// // const mapFormVrEvents = (data) => ({
// //     id: Math.random().toString(36).substr(2, 9),
// //     title: data.setup.roomName,
// //     start: new Date(data.setup.date),
// //     end: new Date(data.setup.date),
// //     meta: {
// //         scenario: data.setup.scenario ?? null,
// //         description: "VR",
// //         type: "special",
// //         status: "upcoming",
// //         isRecurring: false,
// //         createdAt: data.setup.date,
// //         updatedAt: data.setup.date,
// //         MaxPlayers: data.setup.maxPlayers,
// //         RequiredPlayersToStart: data.setup.requiredPlayersToStart,
// //     },
// // });

// const mapFormVrEvents = (data) => {
//     const date = normalizeDateString(data.setup.date);

//     if (!date || isNaN(date)) {
//         console.warn('Invalid VR date:', data.setup.date);
//     }

//     return {
//         id: Math.random().toString(36).substr(2, 9),
//         title: data.setup.roomName,
//         start: date,
//         end: date,
//         meta: {
//             scenario: data.setup.scenario ?? null,
//             description: "VR",
//             type: data.type ?? "special",
//             status: data.live ? "live" : "upcoming",
//             isRecurring: false,
//             createdAt: date,
//             updatedAt: date,
//             MaxPlayers: data.setup.maxPlayers,
//             RequiredPlayersToStart: data.setup.requiredPlayersToStart,
//         },
//         players: data.players || [],
//     };
// };


// // const initialEvents = [
// //     {
// //         id: 0,
// //         title: "Spotkanie z Janem",
// //         start: new Date(),
// //         end: new Date(new Date().getTime() + 60 * 60 * 1000),
// //         personId: 1,
// //     },
// //     {
// //         id: 1,
// //         title: "Przegląd projektu z Anną",
// //         start: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
// //         end: new Date(new Date().getTime() + 3 * 60 * 60 * 1000),
// //         personId: 2,
// //     },
// // ];

// export default function EventsCalendar({ userRole }) {
//     // const [events, setEvents] = useState(initialEvents);

//     const { user } = useSelector((state) => state.auth);


//     const [dialogOpen, setDialogOpen] = useState(false);
//     const [selectedSlot, setSelectedSlot] = useState(null);

//     const [selectedEvent, setSelectedEvent] = useState(null);

//     const [events, setEvents] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const [groups, setGroups] = useState([]);
//     const [selectedGroup, setSelectedGroup] = useState("");

//     const [scenarioNamesForPicker, setScenarioNamesForPicker] = useState(null);


//     const [alert, setAlert] = useState(null);

//     console.log('alert', alert)

//     useEffect(() => {
//         const fetchUserGroups = async () => {
//             const storedUser = JSON.parse(localStorage.getItem("user"));
//             if (!storedtoken) return;

//             const response = await axios.get(
//                 `${process.env.REACT_APP_API_URL}/users-permissions/auth/my-groups`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${storedtoken}`,
//                     },
//                 }
//             );

//             setGroups(response.data);
//         };

//         fetchUserGroups();
//     }, []);

//     // useEffect(() => {
//     //     if (!selectedGroup || !token) return;

//     //     console.log('selectedGroup', selectedGroup)

//     //     const fetchEvents = async () => {
//     //         setLoading(true);

//     //         try {
//     //             const res = await fetch(
//     //                 `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups`,
//     //                 {
//     //                     method: "POST",
//     //                     headers: {
//     //                         "Content-Type": "application/json",
//     //                         Authorization: `Bearer ${token}`,
//     //                     },
//     //                     body: JSON.stringify({
//     //                         groups: [selectedGroup],
//     //                     }),
//     //                 }
//     //             );

//     //             const data = await res.json();

//     //             const mappedEvents = data.map(mapApiEventToCalendarEvent);

//     //             setEvents(mappedEvents);

//     //         } catch (err) {
//     //             console.error("Błąd pobierania wydarzeń", err);
//     //         } finally {
//     //             setLoading(false);
//     //         }
//     //     };

//     //     fetchEvents();

//     // }, [selectedGroup, token]);

//     useEffect(() => {
//         if (!token) return;

//         const controller = new AbortController();
//         const signal = controller.signal;

//         const fetchAllEvents = async () => {
//             setLoading(true);
//             try {
//                 const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                     signal,
//                 });
//                 const res2 = await fetch(`${process.env.REACT_APP_API_URL_VR}/server/map`, { signal });
//                 const res3 = await fetch("https://strapitest.vccsystem.eu/api/scenario-names", { signal });

//                 const data = await res.json();
//                 const data2 = await res2.json();
//                 const data3 = await res3.json();

//                 const mappedVrEvents = data2?.lobbies.map(mapFormVrEvents) || [];
//                 const mappedEvents = (data || []).map(mapApiEventToCalendarEvent);

//                 setEvents([...mappedEvents, ...mappedVrEvents]);

//                 const mappedScenarioNames = data3?.data?.map((scenario) => ({
//                     name: scenario.attributes.displayName,
//                     scenarioName: scenario.attributes.name,
//                 })) || [];

//                 setScenarioNamesForPicker(mappedScenarioNames);
//                 setEvents((prev) => [...prev, ...mappedScenarioNames]);

//             } catch (err) {
//                 if (err.name === "AbortError") return;
//                 console.error("Błąd pobierania wydarzeń", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         const fetchEventsForGroups = async (groups) => {
//             setLoading(true);
//             try {
//                 const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups`, {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                     body: JSON.stringify({ groups }),
//                     signal,
//                 });

//                 const data = await res.json();
//                 if (Array.isArray(data)) {
//                     const mappedEvents = data.map(mapApiEventToCalendarEvent);
//                     setEvents(mappedEvents);
//                 } else {
//                     setEvents([]);
//                 }
//             } catch (err) {
//                 if (err.name === "AbortError") return;
//                 console.error("Błąd pobierania wydarzeń dla grup", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         const load = async () => {
//             if (!selectedGroup || selectedGroup === "global") {
//                 await fetchAllEvents();
//             } else {
//                 await fetchEventsForGroups([selectedGroup]);
//             }
//         };

//         load();

//         return () => controller.abort();
//     }, [selectedGroup, token]);

//     // useEffect(() => {
//     //     const fetchEvents = async () => {
//     //         setLoading(true);
//     //         try {
//     //             const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, {
//     //                 headers: {
//     //                     "Authorization": `Bearer ${token}`
//     //                 }
//     //             });
//     //             const res2 = await fetch(`${process.env.REACT_APP_API_URL_VR}/server/map`);
//     //             const res3 = await fetch("https://strapitest.vccsystem.eu/api/scenario-names");
//     //             const data = await res.json();
//     //             const data2 = await res2.json();
//     //             const data3 = await res3.json();

//     //             console.log('data2', data2)

//     //             const mappedVrEvents = data2?.lobbies.map(mapFormVrEvents);

//     //             const mappedEvents = data.map(mapApiEventToCalendarEvent);

//     //             setEvents([...mappedEvents, ...mappedVrEvents]);

//     //             const mappedScenarioNames = data3?.data?.map((scenario) => ({
//     //                 name: scenario.attributes.displayName,
//     //                 scenarioName: scenario.attributes.name,
//     //             }));

//     //             setScenarioNamesForPicker(mappedScenarioNames);

//     //             setEvents((prevEvents) => [...prevEvents, ...mappedScenarioNames]);

//     //         } catch (err) {
//     //             console.error("Błąd pobierania wydarzeń", err);
//     //         } finally {
//     //             setLoading(false);
//     //         }
//     //     };

//     //     const fetchUserGroups = async () => {
//     //         const user = JSON.parse(localStorage.getItem("user"));
//     //         if (!token) throw new Error("User not logged in");

//     //         const response = await axios.get(`${process.env.REACT_APP_API_URL}/users-permissions/auth/my-groups`, {
//     //             headers: {
//     //                 Authorization: `Bearer ${token}`,
//     //             },
//     //         });

//     //         setGroups(response.data);

//     //         return response.data;
//     //     };

//     //     fetchEvents();
//     //     fetchUserGroups();
//     // }, [events.length, token]);


//     console.log('events', events)
//     console.log('scenarioNamesForPicker', scenarioNamesForPicker)


//     const handleEventResize = ({ event, start, end }) => {
//         if (userRole !== roles.ADMIN) return;
//         setEvents(events.map((evt) => (evt.id === event.id ? { ...evt, start, end } : evt)));
//     };

//     // const handleEventDrop = ({ event, start, end }) => {
//     //     if (userRole !== roles.ADMIN) return;
//     //     setEvents(events.map((evt) => (evt.id === event.id ? { ...evt, start, end } : evt)));
//     // };

//     const handleEventDrop = async ({ event, start, end }) => {
//         console.log('handleEventDrop', event, start, end)
//         if (userRole !== roles.ADMIN) return;

//         const updatedEvent = { ...event, start, end };

//         setEvents((prev) =>
//             prev.map((e) => (e.id === event.id ? updatedEvent : e))
//         );

//         await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${event.id}`, {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
//             body: JSON.stringify({
//                 name: event.title,
//                 startDate: toISOStringSafe(start),
//                 endDate: toISOStringSafe(end),
//             }),
//         });
//     };


//     // const eventStyleGetter = (event) => {
//     //     const person = people.find((p) => p.id === event.personId);
//     //     // const backgroundColor = person?.id === 1 ? "#47be2fff" : "#294e6b";
//     //     const backgroundColor = event?.meta.type === 1 ? "#47be2fff" : "#294e6b";
//     //     return { style: { backgroundColor, color: "white" } };
//     // };

//     const eventStyleGetter = (event) => {
//         console.log('222222222222222event', event)
//         const type = event?.meta?.type;
//         const backgroundColor = EVENT_TYPE_COLORS[type] || "#6b7280";

//         return {
//             style: {
//                 backgroundColor,
//                 color: "white",
//                 borderRadius: "6px",
//                 border: "none",
//             },
//         };
//     };

//     const handleSelectEvent = (event) => {
//         if (userRole !== roles.ADMIN) return;
//         setSelectedEvent(event);
//         setDialogOpen(true);
//     };

//     const handleSelectSlot = (slotInfo) => {
//         if (userRole !== roles.ADMIN) return alert("Brak uprawnień");
//         setSelectedSlot(slotInfo);
//         setSelectedEvent(null);
//         setDialogOpen(true);
//     };

//     const handleSaveEvent = async (data) => {
//         const payload = mapFormToApiPayload(data);

//         if (selectedEvent) {
//             const res = await fetch(
//                 `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${selectedEvent.id}`,
//                 {
//                     method: "PATCH",
//                     headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
//                     body: JSON.stringify(payload),
//                 }
//             );

//             const updated = await res.json();

//             setEvents((prev) =>
//                 prev.map((evt) =>
//                     evt.id === selectedEvent.id ? mapFormToApiPayload(updated) : evt
//                 )
//             );

//             // setSelectedEvent(null);
//             setSelectedEvent(updated);
//             return;
//         }

//         const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
//             body: JSON.stringify(payload),
//         });

//         const created = await res.json();

//         setEvents((prev) => [
//             ...prev,
//             mapFormToApiPayload(created),
//         ]);

//         // setSelectedEvent(null);
//         setSelectedEvent(created);
//     };



//     const handleCloseDialog = () => {
//         setDialogOpen(false);
//         setSelectedEvent(null);
//         setSelectedSlot(null);
//     };
//     const handleJoin = async (id) => {
//         try {
//             const updatedEvent = await joinEvent(id, token);

//             const participants = (updatedEvent.participants || []).map(p => ({
//                 id: p.id,
//                 name: p.username || p.name,
//             }));

//             setEvents(prev =>
//                 prev.map(evt =>
//                     evt.id === id
//                         ? { ...evt, meta: { ...evt.meta, participants } }
//                         : evt
//                 )
//             );

//             if (selectedEvent?.id === id) {
//                 console.log('participants', participants)
//                 setSelectedEvent(prev => ({
//                     ...prev,
//                     meta: { ...prev.meta, participants },
//                 }));
//             }

//             setAlert({ severity: "success", message: "Dołączono do wydarzenia" });

//         } catch (err) {
//             setAlert({ severity: "error", message: err.message });
//         }
//     };

//     const handleLeave = async (id) => {
//         try {
//             const updatedEvent = await leaveEvent(id, token);

//             setEvents((prev) =>
//                 prev.map((evt) =>
//                     evt.id === id
//                         ? {
//                             ...evt,
//                             meta: {
//                                 ...evt.meta,
//                                 participants: (updatedEvent.participants || evt.meta.participants).map(p => ({
//                                     id: p.id,
//                                     name: p.username
//                                 })),
//                             },
//                         }
//                         : evt
//                 )
//             );

//             setSelectedEvent(prev =>
//                 prev?.id === id
//                     ? {
//                         ...prev,
//                         meta: {
//                             ...prev.meta,
//                             participants: (updatedEvent.participants || prev.meta.participants)
//                                 .map(p => ({ id: p.id, name: p.username })),
//                         },
//                     }
//                     : prev
//             );

//             setAlert({
//                 severity: "success",
//                 message: "Wypisano z wydarzenia",
//             });

//         } catch (err) {
//             setAlert({
//                 severity: "error",
//                 message: err.message,
//             });
//         }
//     };


//     const handleDeleteEvent = async () => {
//         try {
//             const response = await fetch(
//                 `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${selectedEvent.id}`,
//                 {
//                     method: 'DELETE',
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                     body: JSON.stringify({
//                         pin: selectedEvent.pin ?? '1111'
//                     })
//                 }
//             );

//             const data = await response.json();

//             if (!response.ok) {
//                 let message = "Failed to delete event";
//                 if (data.errors) {
//                     message = Object.values(data.errors).flat().join(", ");
//                 } else if (data.title) {
//                     message = data.title;
//                 } else if (data.message) {
//                     message = data.message;
//                 }

//                 setAlert({
//                     severity: "error",
//                     message,
//                 });

//                 return;
//             }

//             setEvents(prev => prev.filter(evt => evt.id !== selectedEvent.id));
//             setAlert({
//                 severity: "success",
//                 message: "Event deleted successfully!",
//             });
//             setDialogOpen(false);

//         } catch (error) {
//             console.error('Failed to delete event:', error);
//             setAlert({
//                 severity: "error",
//                 message: error.message || "Unknown error",
//             });
//         }
//     };

//     const handleChangeGroup = (event) => {
//         setSelectedGroup(event.target.value);
//     };

//     // const handleDeleteEvent = async () => {
//     //     try {
//     //         await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${selectedEvent.id}`, {
//     //             method: 'DELETE',
//     //             headers: {
//     //                 "Authorization": `Bearer ${token}`
//     //             },
//     //             body: JSON.stringify({
//     //                 pin: selectedEvent.pin ?? '1111'
//     //             })
//     //         });

//     //         setEvents((prev) =>
//     //             prev.filter((evt) => evt.id !== selectedEvent.id)
//     //         );

//     //         setAlert({
//     //     severity: "success",
//     //     message: "Event deleted successfully!",
//     //   });

//     //         setDialogOpen(false);
//     //     } catch (error) {
//     //         console.error('Failed to delete event:', error);
//     //     }
//     // };


//     // const CustomEvent = ({ event }) => (
//     //     <div>
//     //         <strong>{event.title}</strong>
//     //         <div style={{ fontSize: 12 }}>
//     //             maksymalna liczba graczy: {event.meta.MaxPlayers}
//     //         </div>
//     //         <div style={{ fontSize: 12 }}>
//     //             wymagani gracze {event.meta.RequiredPlayersToStart}
//     //         </div>
//     //         <div style={{ fontSize: 12 }}>
//     //             opis: {event.meta.description}
//     //         </div>
//     //         <div style={{ fontSize: 12 }}>
//     //             scenariusz: {event.meta.scenario}
//     //         </div>
//     //     </div>
//     // )

//     // const CustomEvent = ({ event }) =>
//     //     console.log('eve33', event)



//     return (
//         <div style={{ height: "850px", margin: "50px" }}>
//             <FormControl fullWidth sx={{ mb: 3 }}>
//                 <InputLabel id="demo-simple-select-label">Wybierz grupę aby wyświetlić wydarzenia do niej przypisane</InputLabel>
//                 <Select
//                     labelId="demo-simple-select-label"
//                     id="demo-simple-select"
//                     value={selectedGroup ? selectedGroup : 'global'}
//                     label="Wybierz grupę aby wyświetlić wydarzenia do niej przypisane"
//                     onChange={handleChangeGroup}
//                 >
//                     <MenuItem key={'global'} value={'global'}>Publiczne wydarzenia</MenuItem>
//                     {groups.map(group => (
//                         <MenuItem key={group.id} value={group.code}>{group.name}</MenuItem>
//                     ))}
//                 </Select>
//             </FormControl>

//             <DnDCalendar
//                 popup
//                 localizer={localizer}
//                 events={events}
//                 components={{
//                     event: CustomEvent,
//                 }}
//                 startAccessor="start"
//                 endAccessor="end"
//                 culture="pl-PL"
//                 messages={messagesPL}
//                 selectable={userRole === roles.ADMIN}
//                 onSelectSlot={handleSelectSlot}
//                 onSelectEvent={handleSelectEvent}
//                 onEventDrop={handleEventDrop}
//                 onEventResize={handleEventResize}
//                 resizable
//                 eventPropGetter={eventStyleGetter}
//             />


//             {/* {alert && (
//                 <Alert variant="outlined" severity={alert.severity} style={{ marginTop: 16 }}>
//                     {alert.message}
//                 </Alert>
//             )} */}

//             <EventDialog
//                 open={dialogOpen}
//                 onClose={handleCloseDialog}
//                 onSave={handleSaveEvent}
//                 onDelete={handleDeleteEvent}
//                 slot={selectedSlot}
//                 event={selectedEvent}
//                 scenarioNames={scenarioNamesForPicker}
//                 alert={alert}
//                 joinEvent={handleJoin}
//                 leaveEvent={handleLeave}
//                 currentUser={user}
//             />
//         </div>
//     );
// }
